/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApiFieldValidationResult
 */
export interface ApiFieldValidationResult {
    /**
     *
     * @type {string}
     * @memberof ApiFieldValidationResult
     */
    fieldName?: string;
    /**
     * 1-based row reference for validation result. 0 indicates validation result for whole column
     * @type {number}
     * @memberof ApiFieldValidationResult
     */
    row?: number;
    /**
     * 1-based column reference for validation result. 0 indicates validation result for whole row
     * @type {number}
     * @memberof ApiFieldValidationResult
     */
    column?: number;
    /**
     * If non-zero, check Message for the error description
     * @type {number}
     * @memberof ApiFieldValidationResult
     */
    errorNo?: number;
    /**
     *
     * @type {string}
     * @memberof ApiFieldValidationResult
     */
    message?: string;
    /**
     *
     * @type {number}
     * @memberof ApiFieldValidationResult
     */
    identity?: number;
    /**
     *
     * @type {string}
     * @memberof ApiFieldValidationResult
     */
    identityStr?: string;
}

/**
 * Check if a given object implements the ApiFieldValidationResult interface.
 */
export function instanceOfApiFieldValidationResult(
    value: object,
): value is ApiFieldValidationResult {
    return true;
}

export function ApiFieldValidationResultFromJSON(
    json: any,
): ApiFieldValidationResult {
    return ApiFieldValidationResultFromJSONTyped(json, false);
}

export function ApiFieldValidationResultFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ApiFieldValidationResult {
    if (json == null) {
        return json;
    }
    return {
        fieldName: json["fieldName"] == null ? undefined : json["fieldName"],
        row: json["row"] == null ? undefined : json["row"],
        column: json["column"] == null ? undefined : json["column"],
        errorNo: json["errorNo"] == null ? undefined : json["errorNo"],
        message: json["message"] == null ? undefined : json["message"],
        identity: json["identity"] == null ? undefined : json["identity"],
        identityStr:
            json["identityStr"] == null ? undefined : json["identityStr"],
    };
}

export function ApiFieldValidationResultToJSON(
    value?: ApiFieldValidationResult | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        fieldName: value["fieldName"],
        row: value["row"],
        column: value["column"],
        errorNo: value["errorNo"],
        message: value["message"],
        identity: value["identity"],
        identityStr: value["identityStr"],
    };
}
